import * as angular from 'angular';

import interceptors from './interceptors';
import server from './server-services';
import {HttpCacheService} from "./cache.service";

export default angular.module('dataforvalter.server', [])
    .config(interceptors)
    .service('server', server)
    .service('$httpCacheService', HttpCacheService)
    .name;
